const runtimeConfig =
  typeof window !== "undefined" && window.__APP_CONFIG__
    ? window.__APP_CONFIG__
    : {};

export const AUTH_URL =
  runtimeConfig.REACT_APP_AUTH_URL || process.env.REACT_APP_AUTH_URL || "";

export const IMAGE_URL =
  runtimeConfig.REACT_APP_IMAGE_URL || process.env.REACT_APP_IMAGE_URL || "";
